import React from 'react';
import ChatBot from 'react-simple-chatbot';

import Custom from './CustomChatBot';
import Space from "./Space";
import Landing from "./Landing";
import Work from "./Work.js";
import Dribbble from "./Dribbble";
import Blogs from "./Blogs.js";
import Product from './Product';
import Social from './Social';
import About from './About';
import Contact from './Contact';
import Footer from './Footer';
import Navbar from './NavBar/NavBar';

export default function Home(props){
    const {theme, setTheme} = props;
    return(
        <div>
            <Navbar theme={theme} setTheme={setTheme} />
            <Landing />
            <Custom data-aos="fade-up" />
            <Space />
            <Work />
            <Dribbble />
            <Product />
            <Blogs />
            <Social />
            <About />
            {/* <Contact /> */}
            <Footer theme={theme} />
        </div>
    )
}